import { z } from 'zod'
import { blockSchema } from '.'

export const blockWithPathSchema = blockSchema.and(
  z.object({
    relativePath: z.array(z.string()),
    relationships: z
      .array(
        z.object({
          blockId: z.string(),
          sourceBlockId: z.string(),
        })
      )
      .optional(),
  })
)

export type BlockWithPath = z.infer<typeof blockWithPathSchema>
